import React from "react";

import styles from "./layout.module.css";
import MainSidebar from "../mainSidebar";
import Header from "../header";
import Footer from "../newFooter";
import AppShell from "../appShell";
import { APP_SHELL_V2 } from "../../constants/featureFlags";

const Layout = ({ keycloak, isShowFooter, footerInfo, socialLinks, children }) => {
  // GROWTH-8166: the app shell replaces the sidebar and header below; the old pair stays until the shell is signed off.
  if (APP_SHELL_V2) {
    return (
      <>
        <AppShell keycloak={keycloak}>{children}</AppShell>

        {!isShowFooter && <Footer footerInfo={footerInfo} socialLinks={socialLinks} />}
      </>
    );
  }

  return (
    <>
      <div className={styles.page}>
        <MainSidebar keycloak={keycloak} />
        <div className={styles.content}>
          <Header keycloak={keycloak} />

          {children}
        </div>
      </div>

      {!isShowFooter && <Footer footerInfo={footerInfo} socialLinks={socialLinks} />}
    </>
  );
};

// Layout receives route element children that change identity each render, so memo does not provide value here.
export default Layout;
